export type YaraConnectionStatusResponse = {
  cloud_retro_enabled: boolean;
  local_retro_enabled: boolean;
  cm_retro_enabled: boolean;
};
